import React, { lazy, useState, Suspense, useEffect } from "react";
import { Link as RouterLink, useParams, useHistory, generatePath } from "react-router-dom";
import clsx from "clsx";
// Material UI
import {
  Typography,
  Box,
  Tabs,
  Tab,
  Link,
  useMediaQuery,
} from "@material-ui/core";

//design-system
import StatusCourseCard from "../../../design-system/components/Cards/StatusCourseCard/StatusCourseCard.jsx";
import { getSourceBySourceAndCompany } from "../../../design-system/utils/source.js";

// SDK-POINT
import { CourseService, STATUS_COURSES } from "@sdk-point/talisis";

//Shared
import LoaderContent from "../../../shared/components/Loader/LoaderContent.jsx";
import { getSessionCookie } from "../../../shared/utils/Sessions.js";
import { log } from "../../../shared/utils/console.js";
import getConnectionAllies from "../../../shared/components/Allies/AlliesConnect.jsx";

const LABEL_IN_PROCESS = "En progreso";
const LABEL_COMPLETED = "Completados";
const INDEX_TAB_IN_PROGRESS = 0;
const INDEX_TAB_COMPLETADO = 1;
const CourseCardMedia = lazy(() =>
  import(/**/ "../../../shared/components/CourseCard/CourseCardMedia.jsx")
);

const objectIsEmpty = (obj) => !obj || Object.keys(obj).length === 0;

const programService = {
  postPersonEnrollToClass: async () => Promise.resolve(),
};
const changeStatusEnrollmentCourse = (courseId) => {};

const EduconCourses = () => {
  const [valueActive, setValueActive] = useState(0);
  const [statusCourse, setStatusCourse] = useState(STATUS_COURSES.IN_PROGRESS);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = React.useState(false);
  const isResponsive = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const { company_id, source_id } = useParams();
  const user = getSessionCookie();
  const courseService = new CourseService(
    process.env.REACT_APP_ENV,
    process.env.REACT_APP_X_API_KEY
  );
  const history = useHistory();

  const pageNumber = 1;
  const pageSize = 30;

  useEffect(() => {
    getCourses();
  }, [statusCourse]);

  const getCourses = async () => {
    try {
      setLoading(() => true);
      setCourses(() => []);
      let response = [];
      if (company_id) {
        response = await courseService.getCouresEduconByPersonIdAndCompanyId(
          user.person_id,
          company_id,
          statusCourse,
          pageNumber,
          pageSize
        );
      }
      if (source_id) {
        response = await courseService.getCouresEduconByPersonIdAndSourceId(
          user.person_id,
          source_id,
          statusCourse,
          pageNumber,
          pageSize
        );
      }
      setCourses(() => response);
    } catch (e) {
      log("Error get Courses", e);
    } finally {
      setLoading(() => false);
    }
  };

  const handleChangeTab = (event, newTabIndex) => {
    setValueActive(() => newTabIndex);
    if (newTabIndex === INDEX_TAB_IN_PROGRESS) {
      setStatusCourse(() => STATUS_COURSES.IN_PROGRESS);
    }
    if (newTabIndex === INDEX_TAB_COMPLETADO) {
      setStatusCourse(() => STATUS_COURSES.COMPLETED);
    }
  };

  const handleClickGoToCourse = (course) => async () => {
    const route =
      window.location.protocol +
      "//" +
      window.location.host +
      "/redireccionando/" +
      course.source_id;
    let win = window.open(route, "_blank");
    goToCourse(win, course);
  };

  const handleClickRegisterToCourse = (course) => async () => {
    if (!objectIsEmpty(user)) {
      try {
        const route =
          window.location.protocol +
          "//" +
          window.location.host +
          "/redireccionando/" +
          course.source_id;
        const win = window.open(route, "_blank");
        const body = {
          course_id: course.course_id,
          source_id: course.source_id,
          company_id: course.company_id,
          class_id: course.third_party_id,
        };

        try {
          await programService.postPersonEnrollToClass(user.person_id, body);
          changeStatusEnrollmentCourse(course.course_id);
          goToCourse(win, course);
        } catch (err) {}
      } catch (err) {
        log(err);
      }
    }
  };

  const goToCourse = async (win, course) => {
        try {
            const body = {
                person_id: user?.person_id,
                email: user?.email,
                ou: user?.ou,
                course_url: course.course_url,
                source_id: course.source_id,
                course_url_neo: course.course_url_neo,
                course_id: course.course_id,
                company_id: course.company_id
            }

            var urlRespuesta = await getConnectionAllies(body);

            setTimeout(() => {
                win.focus();
                win.location.replace(urlRespuesta);
            }, 3000);
        } catch(error) {
            log(error);
        }
    };

  return (
    <Box>
      <Box display="flex">
        <i className="ri-arrow-left-s-line text-orange-300"></i>
        <Link component={RouterLink} to="/cursos">
          <Typography
            variant="v2"
            className="text-orange-300"
            style={{ marginLeft: "10px" }}
          >
            Volver a mi Clases{" "}
          </Typography>
        </Link>
      </Box>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={valueActive}
        onChange={handleChangeTab}
        aria-label="scrollable auto tabs example"
        indicatorColor="primary"
      >
        <Tab label={LABEL_IN_PROCESS} />
        <Tab label={LABEL_COMPLETED} />
      </Tabs>
      <Box>
        <LoaderContent loading={loading} minHeight="290px">
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              display="flex"
              flexWrap="inherit"
              justifyContent="left"
              alignItems="center"
              maxWidth="1224px"
              gridGap="24px"
            >
              {courses.map((course, index) => (
                <StatusCourseCard
                  courseId={course.course_id}
                  userId={parseInt(user.person_id ?? 0)}
                  sourceIdLogo={
                    course.showLogoSource &&
                    getSourceBySourceAndCompany(
                      course.source_id,
                      course.company_id
                    )
                  }
                  enrollmentStatusId={course?.enrollment_status_id || 3}
                  media={{
                    backgroundImage: course.image_url,
                    modalityId: course.modality_id,
                    percentage:
                      statusCourse === STATUS_COURSES.COMPLETED
                        ? 100
                        : course.progress_percentage,
                  }}
                  content={{
                    courseName: course.name ? course.name.slice(0, 87) : "",
                    grade: course.grade,
                  }}
                  isLogged={true}
                  companyId={course.company_id}
                  showDetailButton={false}
                  onClickGoToCourse={handleClickGoToCourse(course)}
                  onClickRegister={handleClickRegisterToCourse(course)}
                  approved={statusCourse === STATUS_COURSES.COMPLETED}
                />
              ))}
            </Box>
          </Box>
        </LoaderContent>
      </Box>
    </Box>
  );
};

export default EduconCourses;
